export default __webpack_public_path__ + "static/media/webTraderIcon6.a57060cc.webp";